module.exports = __webpack_public_path__ + "static/img/B (12).1bf99586.png";